import { store } from '@store';

const getPersonalData = async (to, from, next) => {
  if (from.path !== '/') {
    await store.dispatch('cabinet/loadPageData', to.path);
  }
  next();
};

export default [
  {
    path: '/:language?/personal',
    component: () =>
      import(
        /* webpackChunkName: 'personal-personal' */ '@components/Cabinet/Personal/Personal.vue'
      ),
    beforeEnter: getPersonalData,
  },
  {
    path: '/:language?/personal/history',
    component: () =>
      import(/* webpackChunkName: 'personal-history' */ '@components/Cabinet/History/History.vue'),
    beforeEnter: getPersonalData,
  },
  {
    path: '/:language?/personal/wishlist',
    component: () =>
      import(
        /* webpackChunkName: 'personal-favourite' */ '@components/Cabinet/Favourite/Favorites.vue'
      ),
    beforeEnter: getPersonalData,
  },
  {
    path: '/:language?/personal/warranties',
    component: () =>
      import(
        /* webpackChunkName: 'personal-guarantees' */ '@components/Cabinet/Guarantees/Guarantees.vue'
      ),
    beforeEnter: getPersonalData,
  },
  {
    path: '/:language?/personal/purchases',
    component: () =>
      import(
        /* webpackChunkName: 'personal-purchases' */ '@components/Cabinet/Purchases/Purchases.vue'
      ),
    beforeEnter: getPersonalData,
  },
  {
    path: '/:language?/personal/discounts',
    component: () =>
      import(
        /* webpackChunkName: 'personal-discounts' */ '@components/Cabinet/Discounts/Discounts.vue'
      ),
    beforeEnter: getPersonalData,
  },
];
